import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import { NotificationsGetModel } from "@/commons/services/Notifications";

/** store state model */
export interface NotificationState {
  notification: NotificationsGetModel;
}

/**
 * ### Notification store
 *
 * - store
 *   - 画面表示対象のお知らせ(1件分)を保持する
 * - action, mutation
 *   - お知らせを設定する
 */
@Module({ name: "notification" })
export default class Notification extends VuexModule implements NotificationState {
  /** お知らせ */
  notification: NotificationsGetModel = this.initailizeNotification();

  /** お知らせの初期化 */
  private initailizeNotification(): NotificationsGetModel {
    return {
      created: 0,
      deleteFlag: false,
      endPublish: 0,
      id: 0,
      required: true,
      startPublish: 0,
      text: "",
      title: "",
      updated: 0
    };
  }

  @Mutation
  private SET_NOTIFICATION(notification: NotificationsGetModel): void {
    this.notification = notification;

    return;
  }

  /**
   * ### お知らせ設定
   *
   * - 渡されたお知らせをstoreに設定する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public async setNotification(payload: { notification: NotificationsGetModel }): Promise<void> {
    this.SET_NOTIFICATION(payload.notification);

    return;
  }
}
